export const getters = {
  getModalViewTransaction: state => state.modalViewTransaction,
  getTransactions: state => state.transactions,
  getTransaction: state => state.transaction
};

export default {};
